import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    gap: 16,
}));

export const StyledTextfield = styled(TextField)(() => ({
    width: '550px',
}));

export const StyledButton = styled(Button)(() => ({
    marginTop: '8px',
    
}));

export const StyledUserBox = styled(Box)(() => ({
    display: 'flex',
    width: '550px',
    height: '40px',
    border: '1px solid gray',
    borderRadius: 8,
    alignItems: 'center',
    paddingLeft: 16,

    ':hover': {
        cursor: 'pointer',
        background: '#efefef',
    },
}));
